/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Interest_UnknownInputs */

const en_onboarding_v1_interest_unknown = /** @type {(inputs: Onboarding_V1_Interest_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I don't know.`)
};

const de_onboarding_v1_interest_unknown = /** @type {(inputs: Onboarding_V1_Interest_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich weiß es nicht.`)
};

const pt_br2_onboarding_v1_interest_unknown = /** @type {(inputs: Onboarding_V1_Interest_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não sei.`)
};

const tr_onboarding_v1_interest_unknown = /** @type {(inputs: Onboarding_V1_Interest_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilmiyorum.`)
};

const zh_cn2_onboarding_v1_interest_unknown = /** @type {(inputs: Onboarding_V1_Interest_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我不知道。`)
};

const zh_hk2_onboarding_v1_interest_unknown = /** @type {(inputs: Onboarding_V1_Interest_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我不知道。`)
};

const ko_kr2_onboarding_v1_interest_unknown = /** @type {(inputs: Onboarding_V1_Interest_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`잘 모르겠습니다.`)
};

const ru_ru2_onboarding_v1_interest_unknown = /** @type {(inputs: Onboarding_V1_Interest_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Я не знаю.`)
};

const es_419_onboarding_v1_interest_unknown = /** @type {(inputs: Onboarding_V1_Interest_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No lo sé.`)
};

/**
* | output |
* | --- |
* | "I don't know." |
*
* @param {Onboarding_V1_Interest_UnknownInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_interest_unknown = /** @type {((inputs?: Onboarding_V1_Interest_UnknownInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Interest_UnknownInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_interest_unknown(inputs)
	if (locale === "de") return de_onboarding_v1_interest_unknown(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_interest_unknown(inputs)
	if (locale === "tr") return tr_onboarding_v1_interest_unknown(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_interest_unknown(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_interest_unknown(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_interest_unknown(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_interest_unknown(inputs)
	return es_419_onboarding_v1_interest_unknown(inputs)
});